import { Injectable } from "@angular/core";
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

// Invalid Values
const char_ellipsis = "…";
const char_list_1 = "•";
const char_list_2 = "";
const char_right_quote = "’";
const char_left_quote = "‘";

// Replacement Values
const char_ellipsis_replace = "...";
const char_list_replace = "o";
const char_quote_replace = "'";

@Injectable({
  providedIn: "root"
})
export class HttpParamsInterceptor implements HttpInterceptor {
  private data = {};

  configure(data: object) {
    const instance = new HttpParamsInterceptor();
    instance.data = data;
    return instance;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const params = new HttpParams().set("data", this.fixParameters(this.data));

    let modifiedRequest: HttpRequest<any>;

    if (request.method === "GET") {
      modifiedRequest = request.clone({ params: params });
    } else {
      modifiedRequest = request.clone({ body: params });
    }

    return next.handle(modifiedRequest);
  }

  /**
   * Remove invalid characters from parameters before sending to iSeries
   * @param data : data object sent with HTTP Request
   */
  private fixParameters(data: any): string {
    // Stringify data object
    let d = JSON.stringify(data);

    // Replace all invalid characters in the string that the iseries doesn't like
    // RegExp with 'g' modifier will replace all instances of the string unlike a normal d.replace(value, newValue) which will only replace the first one it finds.
    d = d.replace(new RegExp(char_ellipsis, "g"), char_ellipsis_replace);
    d = d.replace(new RegExp(char_left_quote, "g"), char_quote_replace);
    d = d.replace(new RegExp(char_right_quote, "g"), char_quote_replace);
    d = d.replace(new RegExp(char_list_1, "g"), char_list_replace);
    d = d.replace(new RegExp(char_list_2, "g"), char_list_replace);

    return d;
  }
}
